@if (Vendor) {
  <div class="container-fluid h-100 py-3">
    <div class="row h-100">
      <div class="col flex-grow-1">
        <app-notes-grid
          [gridName]="'ClientVendorHistory'"
          [suppliedQueryData]="suppliedGridQuery"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          (rowClick)="action({ action: 'view', rowData: $event.data })"
        ></app-notes-grid>
      </div>
    </div>
  </div>
}
